export interface ActivityCategory {
  value: string;
  name: string;
  cssClass?: string;
}

export interface ActivityType {
  value: string;
  name: string;
  category: string;
}

export const ACTIVITY_CATEGORIES: ActivityCategory[] = [
  { value: 'sea',      name: 'Sea & Ocean',     cssClass: 'badge-sea' },
  { value: 'land',     name: 'Land & Nature',   cssClass: 'badge-land' },
  { value: 'air',      name: 'Air & Aerial',    cssClass: 'badge-air' },
  { value: 'culture',  name: 'Culture & Shows', cssClass: 'badge-culture' },
  { value: 'food',     name: 'Food & Drink',    cssClass: 'badge-food' },
  { value: 'wellness', name: 'Wellness',        cssClass: 'badge-wellness' },
];

export const ACTIVITY_TYPES: ActivityType[] = [
  // Air (4)
  { value: 'airtours',    name: 'Air Tours (Airplane / Fixed Wing)', category: 'air' },
  { value: 'helicopter',  name: 'Helicopter Tours',                  category: 'air' },
  { value: 'ziplinetour', name: 'Zipline Tours',                     category: 'air' },
  { value: 'parasailing', name: 'Parasailing Rides',                 category: 'air' },
  // Sea (11)
  { value: 'fishing',     name: 'Fishing Charters',                  category: 'sea' },
  { value: 'sailing',     name: 'Sailing Charters',                  category: 'sea' },
  { value: 'sunsetsail',  name: 'Sunset Sails & Cruises',            category: 'sea' },
  { value: 'cruisedinner',name: 'Dinner Cruise',                     category: 'sea' },
  { value: 'snorkeling',  name: 'Snorkeling Tours',                  category: 'sea' },
  { value: 'Molokini',    name: 'Molokini Snorkeling Tours',         category: 'sea' },
  { value: 'scuba',       name: 'Scuba Diving',                      category: 'sea' },
  { value: 'whaletour',   name: 'Whale Watching Tours',              category: 'sea' },
  { value: 'kayaktour',   name: 'Kayak Tours',                       category: 'sea' },
  { value: 'sightseeing', name: 'Sightseeing Boat Tours',            category: 'sea' },
  { value: 'watersport',  name: 'Water Sports',                      category: 'sea' },
  // Land (9)
  { value: 'hikingtour',  name: 'Hiking Tours',                      category: 'land' },
  { value: 'biking',      name: 'Bike Tours',                        category: 'land' },
  { value: 'horseback',   name: 'Horseback Riding Tours',            category: 'land' },
  { value: 'offroad',     name: 'ATV And Off-Road Tours',            category: 'land' },
  { value: 'surflesson',  name: 'Surf Lessons',                      category: 'land' },
  { value: 'attractions', name: 'Attractions',                       category: 'land' },
  { value: 'customevent', name: 'Private Charters & Custom Events',  category: 'land' },
  { value: 'combotour',   name: 'Combo Tour Packages',               category: 'land' },
  { value: 'other',       name: 'Other',                             category: 'land' },
  // Culture (2)
  { value: 'luaus',       name: 'Luaus And Shows',                   category: 'culture' },
  { value: 'Peartour',    name: 'Pearl Harbor Tours',                category: 'culture' },
  // Food (1)
  { value: 'foodtesting', name: 'Farm Tours & Food Tasting Tours',   category: 'food' },
  // Wellness (2)
  { value: 'yoga',           name: 'Yoga',                          category: 'wellness' },
  { value: 'spaandmasssage', name: 'Spa And Massage Packages',      category: 'wellness' },
];

export function getActivityTypesForCategory(category: string): ActivityType[] {
  if (!category) return ACTIVITY_TYPES;
  return ACTIVITY_TYPES.filter(t => t.category === category);
}
